import { TODAY } from 'business/constants';

import {
    dateSpecialValues,
    DynamicFilterOperations as DFO,
    FilterOperations as FO,
} from 'business/definitions';

export const isDynamicOperation = (operation: FilterOperationsT): boolean =>
    (Object.values(DFO) as string[]).includes(operation) ||
    dateSpecialValues.includes(operation);

export const isTodayOperation = (
    operation: FilterOperationsT | DynamicFilterOperationsT,
    value: string,
): boolean =>
    [FO.greater_or_equal, FO.lower_or_equal].includes(operation) &&
    value === TODAY;
